'use strict';

var utilsVVS = function () {
  var _animatedScroll = function _animatedScroll($elem) {
    var target = $elem.offset().top - 100;
    $('html, body').animate({
      scrollTop: target
    }, 500);
  };

  var _absoluteURL = function _absoluteURL($elem) {
    var href = $($elem).attr('href');
    var url = window.location.href + '/' + href;
    $($elem).attr('href', url);
  };

  var _getUrlParameter = function _getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
      sParameterName = sURLVariables[i].split('=');

      if (sParameterName[0] === sParam) {
        return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
      }
    }
  };

  var _formatPrice = function _formatPrice(price, d) {
    var priceFormated = new Intl.NumberFormat('es', {
      style: 'decimal',
      maximumFractionDigits: typeof d !== 'undefined' ? d : 0,
      minimumFractionDigits: typeof d !== 'undefined' ? d : 0
    }).format(price);

    if (price === 0) priceFormated = 0;

    return priceFormated;
  };

  var _getDisplayModelName = function _getDisplayModelName(stringModelName) {
    var modelNameInput = stringModelName.toUpperCase();
    var matchNew = modelNameInput.match(/NUEV[OA]|NOV[OA]/);
    var name = modelNameInput;
    var obj = {};
    if (matchNew !== null) {
      obj.new = matchNew[0];
      name = modelNameInput.replace(matchNew[0], '').trim();
    }
    obj.name = name.replace('E-', 'e-');
    obj.completeName = obj.hasOwnProperty('new') ? obj.new + ' ' + obj.name : obj.name;
    var urlName = obj.hasOwnProperty('new') ? obj.new + '-' + obj.name : obj.name;
    obj.urlName = urlName.toLowerCase();

    return obj;
  };

  var _capitalize = function _capitalize(string) {
    if (typeof string !== 'string') return '';
    return '' + string.charAt(0).toUpperCase() + string.slice(1);
  };

  var _sortArrayOfObjects = function _sortArrayOfObjects(objects, property) {
    var compare = function compare(a, b) {
      var propertyA = a[property];
      var propertyB = b[property];

      var comparison = 0;
      if (propertyA > propertyB) {
        comparison = 1;
      } else if (propertyB > propertyA) {
        comparison = -1;
      }
      return comparison;
    };

    return objects.sort(compare);
  };

  return {
    animatedScroll: _animatedScroll,
    absoluteURL: _absoluteURL,
    getUrlParameter: _getUrlParameter,
    formatPrice: _formatPrice,
    getDisplayModelName: _getDisplayModelName,
    capitalize: _capitalize,
    sortArrayOfObjects: _sortArrayOfObjects
  };
}();